import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import isUndefined from 'lodash/isUndefined'

import { commaStyleString } from '../../../common/utils/formatString'

export const FiltersBooleanBody = ({
  name,
  label,
  onChange,
  isChecked,
  isAtTop,
  isAtBottom,
  count,
  icon
}) => {
  icon = icon || name
  const id = `${name}-filter`
  const boxClass = classNames({
    'search-facet-box--start': isAtTop,
    'search-facet-box': !isAtTop && !isAtBottom,
    'search-facet-box--end': isAtBottom
  })

  return (
    <div className="search-facet--no-margin" id={id}>
      <div className={boxClass}>
        <div className="search-facet-box__inner">
          <h2 className="search-facet-box__heading">
            {icon} {label}
          </h2>

          <label className="search-facet-boolean">
            <input
              type="checkbox"
              name={name}
              value="1"
              checked={isChecked}
              onChange={onChange}
            />
            <span className="search-facet-boolean__label">Yes</span>
            {!isUndefined(count) && (
              <span className="search-facet-result-count">
                {commaStyleString(count)}
              </span>
            )}
          </label>
        </div>
      </div>
    </div>
  )
}

FiltersBooleanBody.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  icon: PropTypes.element,
  isAtBottom: PropTypes.bool,
  count: PropTypes.number
}

export default FiltersBooleanBody



// WEBPACK FOOTER //
// ./client/components/filters/filtersBooleanBody.js